
export const ON_PRESS_TAG_DROPDOWN = "mailInboxReducer/ON_PRESS_TAG_DROPDOWN";
export const ON_PRESS_MORE_DROPDOWN = "mailInboxReducer/ON_PRESS_MORE_DROPDOWN";
export const ON_PRESS_COMPOSE = "mailInboxReducer/ON_PRESS_COMPOSE";
export const ON_PRESS_ADD_EVENT = "mailInboxReducer/ON_PRESS_ADD_EVENT";
export const ON_PRESS_ADD_CONTACT = "mailInboxReducer/ON_PRESS_ADD_CONTACT";
export const OPEN_EVENT_DETAIL_MODAL = "mailInboxReducer/OPEN_EVENT_DETAIL_MODAL";
export const CLOSE_EVENT_DETAIL_MODAL = "mailInboxReducer/CLOSE_EVENT_DETAIL_MODAL";
export const SET_EVENTS_COUNTS = "mailInboxReducer/SET_EVENTS_COUNTS";
export const OPEN_ADD_TASK_MODAL = "mailInboxReducer/OPEN_ADD_TASK_MODAL";
export const CLOSE_ADD_TASK_MODAL = "mailInboxReducer/CLOSE_ADD_TASK_MODAL";
export const OPEN_TASK_DETAIL_MODEL = "mailInboxReducer/OPEN_TASK_DETAIL_MODEL";
export const CLOSE_TASK_DETAIL_MODEL = "mailInboxReducer/CLOSE_TASK_DETAIL_MODEL";
export const OPEN_ADD_COLLECTION_MODEL = "mailInboxReducer/OPEN_ADD_COLLECTION_MODEL";
export const CLOSE_ADD_COLLECTION_MODEL = "mailInboxReducer/CLOSE_ADD_COLLECTION_MODEL";
export const OPEN_CUSTOMER_DETAILS_MODEL = "mailInboxReducer/OPEN_CUSTOMER_DETAILS_MODEL";
export const CLOSE_CUSTOMER_DETAILS_MODEL = "mailInboxReducer/CLOSE_CUSTOMER_DETAILS_MODEL";
export const OPEN_VEHICLE_DETAILS_MODEL = "mailInboxReducer/OPEN_VEHICLE_DETAILS_MODEL";
export const CLOSE_VEHICLE_DETAILS_MODEL = "mailInboxReducer/CLOSE_VEHICLE_DETAILS_MODEL";

export const onPressTagDropdown = () => (dispatch) => {
  dispatch({
    type: ON_PRESS_TAG_DROPDOWN,
  });
};

export const onPressMoreDropdown = () => (dispatch) => {
  dispatch({
    type: ON_PRESS_MORE_DROPDOWN,
  });
};
export const onPressCompose = (val) => (dispatch) => {
  dispatch({
    type: ON_PRESS_COMPOSE,
    payload: val,
  });
};

export const onPresAddEvent = () => (dispatch) => {
  dispatch({
    type: ON_PRESS_ADD_EVENT,
  });
};

export const onPressAddContact = () => (dispatch) => {
  dispatch({
    type: ON_PRESS_ADD_CONTACT,
  });
};

export const onLeave = (data) => (dispatch) => {
  console.error(data);
};
export const openModal = (event) => ({
  type: OPEN_EVENT_DETAIL_MODAL,
  payload: event
});
export const openTaskDetailModel = (event) => ({
  type: OPEN_TASK_DETAIL_MODEL,
  payload: event
});
export const closeTaskDetailModel = (event) => ({
  type: CLOSE_TASK_DETAIL_MODEL,
});
export const openCollectionAddModel = (event) => ({
  type: OPEN_ADD_COLLECTION_MODEL,
  payload: event
});
export const closeCollectionAddModel = (event) => ({
  type: CLOSE_ADD_COLLECTION_MODEL,
});
export const openAddTaskModal = (event) => ({
  type: OPEN_ADD_TASK_MODAL,
  payload: event
});
export const closeAddTaskModal = () => ({
  type: CLOSE_ADD_TASK_MODAL,
});
export const openCustomerDetailModel = () => ({
  type: OPEN_CUSTOMER_DETAILS_MODEL,
});
export const closeCustomerDetailModel = () => ({
  type: CLOSE_CUSTOMER_DETAILS_MODEL,
});
export const openVehicleDetailModel = () => ({
  type: OPEN_VEHICLE_DETAILS_MODEL,
});
export const closeVehicleDetailModel = () => ({
  type: CLOSE_VEHICLE_DETAILS_MODEL,
});

export const closeModal = () => ({
  type: CLOSE_EVENT_DETAIL_MODAL
});
export const setEventsCounts = (counts) => ({
  type: SET_EVENTS_COUNTS,
  payload: counts
});
